import React from "react";

export const SkillsList = ({ skillSource, skillName }) => {
  return (
    <div className="shadow-skills-black hover:scale-110 duration-500 pt-4">
      <img
        className="w-20 mx-auto"
        src={skillSource}
        alt={`${skillName} icon`}
      />
      <p className="my-4">{skillName}</p>
    </div>
  );
};
